import * as React from 'react';
import { isDevelopment } from 'app/infrastructure/universal';
import { toJSON } from 'app/infrastructure/platform/json';

/**
 * Global errors represents a non-recoverable application state and is visualized on top of the application layout.
 *
 * This is a developer/testers error panel
 *
 * This is not to be used for predictable use errors such as validation or errors that contain translated hints/messages for the user.
 *
 * - JavaScript error message must never be shown to the user since they're not translated
 *
 */
export class DevErrorPanel extends React.PureComponent<any, any>{
  public state: Readonly<any> = {
    expand: false,
    hide: false
  };

  private toggleIn = (e:any) => {
    e.preventDefault();
    this.setState({ expand: !this.state.expand });
  };

  private close = ()=> this.setState({
    expand: false,
    hide: true
  });

  public render() {

    if (!isDevelopment){
      return null;
    }

    if (!this.state.expand && this.state.hide
    ) {
      return null;
    }

    if (!this.props.errors || !this.props.errors.length ){
      return null;
    }

    const allErrors: any = Array.from(new Set(this.props.errors));

    const details = allErrors.map((err: any, i: number) => {

      const isJsError = err.error && err.error.message;

      return <li key={i} className="list-group-item">

                <strong>
                  {isJsError ? err.error.message.toString() : err.message}
                </strong>

                {
                  // userMessages will be handled by redux middleware and separate ui component
                  err.error.userMessages && err.error.userMessages.length ?

                    err.error.userMessages.map((m: any) => m.message).join('\n')
                    :
                    <i> {toJSON(err.error) || err.message} </i>
                }
              </li>;
    });

    const header = <div className="alert alert-warning" onClick={this.toggleIn}>
                      <span className="badge">{allErrors.length}</span>
                      <small>Problems detected. Click for details</small>
                   </div>;

    if (!this.state.expand) {
      return header;
    }

    const closeButton = <span onClick={this.close}>Dismiss</span>;

    return (
        <div className={this.state.expand ? 'collapse show' : 'collapse'}>

          <div className="card cardblock">

            <ul className="list-group list-group-flush">

              {details}

              <li className="list-group-item">

                  {closeButton}

              </li>
            </ul>
          </div>

        </div>
    );
  }
}
